import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Box, makeStyles, Button } from "@material-ui/core";
import { backend } from "../../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import theme from "../../../theme";

const useStyles = makeStyles((theme) => ({
  mainModal: {
    backgroundColor: theme.palette.darkGray,
  },
  modalContainer: {
    // width: "90%",
    borderRadius: 6,
    padding: "20px 20px",
    backgroundColor: theme.palette.darkGray,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
  modalHeading: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },

  submitBtn: {
    marginLeft: 10,
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 160,
    borderRadius: 13,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 160,
    borderRadius: 13,
    padding: "8px 0",

    color: theme.palette.secondary.light,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },

  text: {
    color: "red",
  },

  btnWrap1: {
    textAlign: "center",
    marginTop: 70,
  },
}));

function GotoCartModal(props) {
  const { visible, closeModal, goToCheckout } = props;
  const classes = useStyles();

  return (
    <Modal
      width="500"
      visible={visible}
      effect="fadeInUp"
      onClickAway={closeModal}
      bgColor={theme.palette.darkGray}
      className={classes.mainModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>
          Item has been added to the cart Successfully.
        </h3>

        <div className={classes.btnWrap1}>
          <Button
            // color="primary"
            className={classes.cancelBtn}
            onClick={closeModal}
          >
            Continue Shopping
          </Button>
          <Button
            // color="primary"
            className={classes.submitBtn}
            onClick={goToCheckout}
          >
            View Cart
          </Button>
        </div>
      </div>
    </Modal>
  );
}
export default GotoCartModal;
